import setupQ2Elements from './elements';
import setupQ2Outlets from './outlets';
import setupQ2Styles from './styles/styles';
import setupAnalytics from './analytics';
import SDKMessageBus from '../utility/message-bus';
import setupGlobalVars from './global-vars';
import { IDict } from '../types/utility';
import { TectonResolvedMenuItem } from '../types/index';
import { Maybe } from 'maybe-not';
import cdnOverrideSetup from './cdnOverride';
import loadDefaultTheme from './styles/loadDefaultTheme';
import { IOverpanelOptions } from '../types';

export default function setup(
    messageBus: SDKMessageBus,
    moduleInstanceId: string,
    loc: (key: string, substitutions?: string[], options?: IDict<any>) => string,
    capabilities: Set<string>,
    teardowns: (() => void)[],
    resizeIframe: () => void,
    resolveMenu: Maybe<
        (
            outletName: string,
            contextValue?: string,
            resolvedType?: string
        ) => Promise<TectonResolvedMenuItem[]>
    >,
    navigateTo: Maybe<(featureName: string, moduleName?: string) => void>,
    showOverpanel: Maybe<
        <T>(overpanelPath: string, props?: IDict<string>, options?: IOverpanelOptions) => Promise<T>
    >
): Promise<() => void> {
    const cdnOverride = cdnOverrideSetup(messageBus, capabilities);
    const cdnOverridePromise = cdnOverride
        ? cdnOverride()
              .then(Maybe.maybe)
              .catch(() => Maybe.nothing<string>())
        : Promise.resolve(Maybe.nothing<string>());
    const elementsProm = setupQ2Elements(
        loc,
        resizeIframe,
        resolveMenu,
        navigateTo,
        showOverpanel,
        teardowns,
        cdnOverridePromise
    );
    const stylesProm = setupQ2Styles(messageBus, moduleInstanceId, capabilities, resizeIframe);
    const defaultThemePromise = loadDefaultTheme(cdnOverride);
    const varsProm = setupGlobalVars(messageBus, capabilities);
    return Promise.all([stylesProm, varsProm, elementsProm, defaultThemePromise]).then(
        ([styleResult]) => {
            setupQ2Outlets(messageBus, moduleInstanceId, loc, resizeIframe);
            setupAnalytics(messageBus, moduleInstanceId, capabilities, cdnOverridePromise);
            return function() {
                styleResult();
            };
        }
    );
}
